import React from "react";

function SiemSection() {
  return (
    <section className="section siem-section" id="siem">
      <div className="container">
        <div className="siem-content" data-aos="fade-right">
          <span className="section-subtitle">Featured Use Case</span>
          <h2>Security Operations Streaming Fabric</h2>
          <p className="section-description">
            Transforming SIEM architectures with real-time data streaming
          </p>

          <div className="siem-problem">
            <h4>Challenges in Modern SOCs:</h4>
            <ul className="checklist">
              <li>
                <i className="fas fa-exclamation-triangle"></i> SIEMs overwhelmed
                with raw logs — costly and noisy
              </li>
              <li>
                <i className="fas fa-clock"></i> Critical security telemetry
                arrives too late or gets dropped
              </li>
              <li>
                <i className="fas fa-bolt"></i> Traditional log collectors can't
                handle burst traffic during incidents
              </li>
              <li>
                <i className="fas fa-search-minus"></i> Limited visibility across
                siloed security tools
              </li>
            </ul>
          </div>

          <div className="siem-solution">
            <h4>Our Solution:</h4>
            <p>
              We implement a real-time security data fabric that sits between
              your security tools and SIEM, providing:
            </p>
            <div className="benefits-grid">
              <div className="benefit-item">
                <div className="benefit-icon">
                  <i className="fas fa-tachometer-alt"></i>
                </div>
                <h5>Scalable Ingestion</h5>
                <p>Handle millions of events per second with zero data loss</p>
              </div>
              <div className="benefit-item">
                <div className="benefit-icon">
                  <i className="fas fa-filter"></i>
                </div>
                <h5>Smart Filtering</h5>
                <p>
                  Reduce SIEM costs by filtering and normalizing before ingestion
                </p>
              </div>
              <div className="benefit-item">
                <div className="benefit-icon">
                  <i className="fas fa-bolt"></i>
                </div>
                <h5>Real-time Enrichment</h5>
                <p>
                  Add context to security events with threat intel and asset data
                </p>
              </div>
              <div className="benefit-item">
                <div className="benefit-icon">
                  <i className="fas fa-shield-alt"></i>
                </div>
                <h5>Compliance Ready</h5>
                <p>
                  Meet regulatory requirements with complete audit trails
                </p>
              </div>
            </div>
          </div>

          <div className="siem-cta">
            <a 
              href="/siemReference" 
              className="btn btn-primary"
              style={{ 
                cursor: 'pointer',
                pointerEvents: 'auto',
              }}
            >
              Get the SIEM Reference Architecture
            </a>
            
          </div>
        </div>

        <div className="siem-visual" data-aos="fade-left">
          <div className="architecture-diagram">
            {/* Placeholder for architecture diagram */}
            <div className="diagram-placeholder">
              <i className="fas fa-project-diagram"></i>
              <p>SIEM Integration Architecture</p>
            </div>

            {/* Data flow animation */}
            <div className="data-flow">
              <div className="source">Security Tools</div>
              <div className="connector"></div>
              <div className="streaming-layer">
                <div className="streaming-label">Confluent Platform</div>
                <div className="streaming-nodes">
                  <div className="node">Ingest</div>
                  <div className="node">Process</div>
                  <div className="node">Enrich</div>
                </div>
              </div>
              <div className="connector"></div>
              <div className="destination">SIEM &amp; Analytics</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SiemSection;
